export interface VsaaTag {
  id: string;
  title: string;
  tagCollectionId: string;
}

export enum TagSortMode {
  Automatic,
  Manual,
}

export interface FlatVsaaTag extends VsaaTag {
  position?: number;
  parentId?: string | undefined;
  ancestorIds?: string[] | undefined;
  level?: number;
  siblings?: number;
  path: string;
  hasChildren?: boolean;
  isTagCollection?: boolean;
  sortMode?: TagSortMode;
}

export interface NavigationNode extends VsaaTag {
  associatedActivityIds?: string[];
  subNodes?: NavigationNode[];
}

export interface CreateTagRequest {
  title: string;
  ancestorIds?: string[];
}

export interface DeleteTagRequest {
  id: string;
  ancestorIds?: string[];
}

export interface UpdateTagRequest {
  id?: string;
  title: string;
  ancestorIds?: string[];
}

export interface SortTagRequest {
  id: string;
  ancestorIds?: string[];
  sortAscending: boolean;
}

export interface RearrangeTagRequest {
  tags: TagsArray[];
  fromAncestorIds?: string[];
  targetAncestorIds?: string[];
}

export interface CopyTagRequest {
  id: string;
  ancestorIds: string[];
  targetAncestorIds: string[];
}

export interface ImportTagRequest {
  tagCollectionId: string;
  tags: FullTag[];
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface FullTagCollection extends FullTag {}
export interface FullTag {
  id: string;
  title: string;
  tags: FullTag[];
}
interface TagsArray {
  id: string;
  targetPosition?: number;
}
